<div class="dashboard-bg">
    <div class="container" style="padding-top: 1rem; max-width: 90rem;">

        <div class="card" style="height: fit-content;">
            <div class="row" style="margin-top: 0.5rem;margin-bottom: 0.5rem;display: flex; justify-content: space-between; margin-left: 50px;">
                <div class="col-md-4 row" style="padding: 0px;">
                    <label class="form-control-label col-md-5" style="font-size:16px;text-align: right;" >Show reports from: </label>
                    <div class="col-md-7">
                    <select class="form-control" [(ngModel)]="period" style="padding: 0px 5px;height: 25px;" (change)="onChange()">
                    <option *ngFor="let c of  periodIntervals" [ngValue]="c">{{c}}</option>
                    </select>
                    </div>
                </div>
                
                <!-- <div class="col-md-3 row" style="padding: 0px;" >
                    <div class="toggle">
                        <input class="SSToggle" type="checkbox" (change)="changeSalesStock($event)" >
                        <label for="" class="stockBtn">Stock</label>
                        <label for="" class="salesBtn">Sales</label>                    
                    </div>
                </div> -->

                <div class="col-md-3 row" style="display: flex; justify-content: center;">
                        <div class="row" style="padding: 0px;" >
                            <div class="toggle">
                                <input class="SSToggle" style="margin-right: 40px;" type="checkbox" (change)="changeSalesStock($event)" >
                                <label for="" class="stockBtn">Stock</label>
                                <label for="" class="salesBtn">Sales</label>                    
                            </div>
                        </div>

                    <div *ngIf="salesstock" class="row" style="padding: 0px;" >
                        <div class="toggle">
                            <input class="dataType" type="checkbox" [(ngModel)]="stockCheck" (change)="onTypeChange()" >
                            <label for="" class="valBtn">VAL</label>
                            <label for="" class="qtyBtn">QTY</label>                    
                        </div>
                    </div>
                    <div *ngIf="!salesstock" class="row" style="padding: 0px;" >
                        <div class="toggle">
                            <input class="dataType" type="checkbox" [(ngModel)]="salesCheck" (change)="onTypeChange()" >
                            <label for="" class="valBtn">VAL</label>
                            <label for="" class="qtyBtn">QTY</label>                    
                        </div>
                    </div>

                        <!-- <div class="col-md-8 row">
                            <div class="toggle" *ngIf="salesstock" >
                                <input class="dataType" [(ngModel)]="stockCheck" type="checkbox" style="width: 193px;" (change)="onTypeChange()" >
                                <label for="" class="valBtn">Stock Value</label>
                                <label for="" class="qtyBtn">Stock Qty</label>                    
                            </div>
                            <div class="toggle" *ngIf="!salesstock" >
                                <input class="dataType" [(ngModel)]="salesCheck" type="checkbox" style="width: 193px;" (change)="onTypeChange()" >
                                <label for="" class="valBtn">Sales</label>
                                <label for="" class="qtyBtn">Unit Sold</label>                    
                            </div>
                        </div> -->

                    <!-- <label class="form-control-label">Type:</label> -->
                </div>

        </div>
        

        <div class="row">
                
            <div class="col-md-4 row"  style="padding: 0px; margin-left: 55px;" *ngIf="period == 'Custom'">
                <label class="form-control-label col-md-2">From:</label>
                <div class="col-md-4" style="padding: 0px;">
                    <input type="date" class="form-control" [(ngModel)]="fromDate" style="padding:0px 5px; width: 100%;font-size:15px;" >
                     <!-- <input type="text" class="form-control" style="padding: 1px 5px; width: 45%; margin-left: 0.5rem;font-size:16px;text-align: right;" > -->
                </div>
                <label class="form-control-label col-md-2">To:</label>
                <div class="col-md-4" style="padding: 0px;">
                    <input type="date" class="form-control"   [(ngModel)]="toDate" style="padding:0px 5px; width: 100%;font-size: 15px;">
                </div>
            </div>
            <div class="col-md-1 row" style="padding: 0px;margin-left: 3px;" *ngIf="period == 'Custom'">
                <button class="btn btn-sm btn-primary" style="margin-left: 2rem;" (click)="loadReport()">Run</button>
                </div>
        </div>

        <div class="row" style="margin-top: 1rem;">
            <div class="col-md-8 p0">
                <div class="card  pie-chart-card">
                    <div class="card-body" >

                        <div style="height: 71vh; overflow-y: scroll;">

                            <ng-container  *ngIf="(ownedData.length !== 0) && (ownedLabels.length !== 0)">
                                <!-- <h5>Owned Stores Sales</h5>  -->
                                <div class="card-header" >
                                    <h5> {{ OwnedStore }} </h5></div>
                              <div class="chart-wrapper">
                                  <canvas baseChart  #ownedWise="base-chart" width="950" height="510"
                                  [data]="ownedData"
                                  [labels]="ownedLabels"
                                  [chartType]="ownedType"
                                  [colors]="ownedColor"
                                  [legend]="ownedLegend"
                                  [options]="ownedOptions"
                                  >
                                </canvas>
                                </div>
                                </ng-container>
                                
                            <ng-container *ngIf="(franchiseWiseData.length !== 0) && (franchiseWiseLabels.length !== 0)">
                        <!-- <h5>Franchise Stores Sales</h5> -->
                        <div class="card-header" ><h5> {{FranchiseStore}} </h5></div>
                        
                        <div class="chart-wrapper"  >
                            <canvas baseChart  #franchiseWise="base-chart" width="950" height="510"
                            [data]="franchiseWiseData"
                            [labels]="franchiseWiseLabels"
                            [chartType]=" franchiseWiseType"
                            [colors]="franchiseWiseColor"
                            [legend]="franchiseWiseLegend"
                            [options]="franchiseWiseOptions"
                            (chartClick)="FranchiseWiseClicked($event)"
                            >
                          </canvas>
                          </div>
                          </ng-container>

                      


                        </div>
                    </div>


                </div>
            </div>

            <div class="col-md-4 pd 0">
                <div class="card pie-chart-card">
                    <div class="card-header">
                        <!-- <div class="card-title">Owned vs Franchise Sales</div> -->
                        <div class="card-title" > {{ OwnedVSFranchise }} </div>
                    </div>
                    <div class="card-body" *ngIf="ownerFranchiseData && ownerFranchiseLabels">
                       
                        <div class="chart-wrapper" style="margin-top: 10vh;">
                            <canvas baseChart #ownerFranchise="base-chart"
                            [data]="ownerFranchiseData" 
                            [labels]="ownerFranchiseLabels" 
                            [chartType]="ownerFranchiseType"
                            [legend]="ownerFranchiseLegend"
                            [options]="ownerFranchiseOptions"
                            [plugins]="ownerFranchisePlugins"
                            [colors]="pieChartColors">
                            
                          </canvas>
                        </div>
                      
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>